import { render } from "./ResetPasswordConfirmView.vue?vue&type=template&id=0bcc6d04&scoped=true"
import script from "./ResetPasswordConfirmView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirmView.vue?vue&type=script&lang=js"

import "./ResetPasswordConfirmView.vue?vue&type=style&index=0&id=0bcc6d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcc6d04"]])

export default __exports__